const darkTheme = {
  colors: {
    background: '#000',
    text: '#FFF',
    panel: '#333',
    primary: '#00F',
    primaryText: '#FFF',
    secondary: '#0F0',
    secondaryText: '#000',
    disabled: '#888',
    disabledText: '#FFF',
  },
};

export default darkTheme;
